/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ClassSignupDTO,
  ClassSignupDTOOptional,
  ClassSignupDTOMetaI,
  ClassSignupDTOTrackedI,
} from "./class-signup-dto";
import { ClassSignupDTOTracked, ClassSignupDTOMeta } from "./class-signup-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ClassSignupEligibilityStatus,
  ClassSignupEligibilityStatusOptional,
  ClassSignupEligibilityStatusMetaI,
  ClassSignupEligibilityStatusTrackedI,
} from "./class-signup-eligibility-status";
import {
  ClassSignupEligibilityStatusTracked,
  ClassSignupEligibilityStatusMeta,
} from "./class-signup-eligibility-status";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ClassSignupInstructorEligibilityDTO,
  ClassSignupInstructorEligibilityDTOOptional,
  ClassSignupInstructorEligibilityDTOMetaI,
  ClassSignupInstructorEligibilityDTOTrackedI,
} from "./class-signup-instructor-eligibility-dto";
import {
  ClassSignupInstructorEligibilityDTOTracked,
  ClassSignupInstructorEligibilityDTOMeta,
} from "./class-signup-instructor-eligibility-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonNameInfoAndRef,
  PersonNameInfoAndRefOptional,
  PersonNameInfoAndRefMetaI,
  PersonNameInfoAndRefTrackedI,
} from "./person-name-info-and-ref";
import {
  PersonNameInfoAndRefTracked,
  PersonNameInfoAndRefMeta,
} from "./person-name-info-and-ref";

/**
 *
 * @export
 * @interface PersonClassEligibility
 */
export interface PersonClassEligibilityOptional {
  /**
   *
   * @type {PersonNameInfoAndRef}
   * @memberof PersonClassEligibility
   */
  personId?: PersonNameInfoAndRefOptional;
  /**
   *
   * @type {ClassSignupEligibilityStatus}
   * @memberof PersonClassEligibility
   */
  eligibilityStatus?: ClassSignupEligibilityStatus;
  /**
   *
   * @type {string}
   * @memberof PersonClassEligibility
   */
  message?: string;
  /**
   *
   * @type {ClassSignupInstructorEligibilityDTO}
   * @memberof PersonClassEligibility
   */
  instructorEligibility?: ClassSignupInstructorEligibilityDTOOptional;
  /**
   *
   * @type {ClassSignupDTO}
   * @memberof PersonClassEligibility
   */
  existingSignup?: ClassSignupDTOOptional;
}

export interface PersonClassEligibility extends PersonClassEligibilityOptional {
  /**
   *
   * @type {PersonNameInfoAndRef}
   * @memberof PersonClassEligibility
   */
  personId: PersonNameInfoAndRef;
  /**
   *
   * @type {ClassSignupEligibilityStatus}
   * @memberof PersonClassEligibility
   */
  eligibilityStatus: ClassSignupEligibilityStatus;
  /**
   *
   * @type {string}
   * @memberof PersonClassEligibility
   */
  message?: string;
  /**
   *
   * @type {ClassSignupInstructorEligibilityDTO}
   * @memberof PersonClassEligibility
   */
  instructorEligibility?: ClassSignupInstructorEligibilityDTO;
  /**
   *
   * @type {ClassSignupDTO}
   * @memberof PersonClassEligibility
   */
  existingSignup?: ClassSignupDTO;
}

export interface PersonClassEligibilityTrackedI {
  /**
   *
   * @type {PersonNameInfoAndRef}
   * @memberof PersonClassEligibility
   */
  personId?: PersonNameInfoAndRefTrackedI;
  personIdIsSet: boolean;
  /**
   *
   * @type {ClassSignupEligibilityStatus}
   * @memberof PersonClassEligibility
   */
  eligibilityStatus?: ClassSignupEligibilityStatus;
  eligibilityStatusIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonClassEligibility
   */
  message?: string;
  messageIsSet: boolean;
  /**
   *
   * @type {ClassSignupInstructorEligibilityDTO}
   * @memberof PersonClassEligibility
   */
  instructorEligibility?: ClassSignupInstructorEligibilityDTOTrackedI;
  instructorEligibilityIsSet: boolean;
  /**
   *
   * @type {ClassSignupDTO}
   * @memberof PersonClassEligibility
   */
  existingSignup?: ClassSignupDTOTrackedI;
  existingSignupIsSet: boolean;
}

transformDatesMap.set(
  "PersonClassEligibility",
  function (model: PersonClassEligibility) {
    const transformDatespersonId = transformDatesMap.get(
      "PersonNameInfoAndRef",
    );
    if (transformDatespersonId && model.personId) {
      transformDatespersonId(model.personId);
    }
    const transformDatesinstructorEligibility = transformDatesMap.get(
      "ClassSignupInstructorEligibilityDTO",
    );
    if (transformDatesinstructorEligibility && model.instructorEligibility) {
      transformDatesinstructorEligibility(model.instructorEligibility);
    }
    const transformDatesexistingSignup =
      transformDatesMap.get("ClassSignupDTO");
    if (transformDatesexistingSignup && model.existingSignup) {
      transformDatesexistingSignup(model.existingSignup);
    }
  },
);

export type PersonClassEligibilityMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  personId: PropertyMeta<PersonNameInfoAndRefMetaI>;
  //isDate: false
  //isDatetime: false
  eligibilityStatus: PropertyMeta<ClassSignupEligibilityStatusMetaI>;
  //isDate: false
  //isDatetime: false
  message: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  instructorEligibility: PropertyMeta<ClassSignupInstructorEligibilityDTOMetaI>;
  //isDate: false
  //isDatetime: false
  existingSignup: PropertyMeta<ClassSignupDTOMetaI>;
}>;

export var PersonClassEligibilityMeta: PersonClassEligibilityMetaI =
  {} as PersonClassEligibilityMetaI;
PersonClassEligibilityMeta = typeMeta("PersonClassEligibility", {
  personId: propertyMeta(
    "personId",
    false,
    true,
    false,
    PersonNameInfoAndRefMeta,
  ),
  eligibilityStatus: propertyMeta(
    "eligibilityStatus",
    false,
    true,
    false,
    ClassSignupEligibilityStatusMeta,
  ),
  message: propertyMeta("message", false, false, false, MetaTypesBase.string),
  instructorEligibility: propertyMeta(
    "instructorEligibility",
    false,
    false,
    false,
    ClassSignupInstructorEligibilityDTOMeta,
  ),
  existingSignup: propertyMeta(
    "existingSignup",
    false,
    false,
    false,
    ClassSignupDTOMeta,
  ),
});

const metaI = PersonClassEligibilityMeta;

registerMeta(() => {});

export class PersonClassEligibilityTracked implements PersonClassEligibilityTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  personId__I?: PersonNameInfoAndRefTracked = undefined;
  personIdIsSet: boolean = false;
  set personId(v: undefined | PersonNameInfoAndRefTracked) {
    if (v !== undefined) {
      this.personId__I = v;
      this.personIdIsSet = true;
    } else {
      this.personId__I = v || undefined;
      this.personIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get personId() {
    return this.personId__I;
  }
  eligibilityStatus__I?: ClassSignupEligibilityStatus = undefined;
  eligibilityStatusIsSet: boolean = false;
  set eligibilityStatus(v: undefined | ClassSignupEligibilityStatus) {
    if (v !== undefined) {
      this.eligibilityStatus__I = v;
      this.eligibilityStatusIsSet = true;
    } else {
      this.eligibilityStatus__I = v || undefined;
      this.eligibilityStatusIsSet = true;
    }
    this.changeTracker = true;
  }
  get eligibilityStatus() {
    return this.eligibilityStatus__I;
  }
  message__I?: string = undefined;
  messageIsSet: boolean = false;
  set message(v: undefined | string) {
    if (v !== undefined) {
      this.message__I = v;
      this.messageIsSet = true;
    } else {
      this.message__I = v || undefined;
      this.messageIsSet = false;
    }
    this.changeTracker = true;
  }
  get message() {
    return this.message__I;
  }
  instructorEligibility__I?: ClassSignupInstructorEligibilityDTOTracked =
    undefined;
  instructorEligibilityIsSet: boolean = false;
  set instructorEligibility(
    v: undefined | ClassSignupInstructorEligibilityDTOTracked,
  ) {
    if (v !== undefined) {
      this.instructorEligibility__I = v;
      this.instructorEligibilityIsSet = true;
    } else {
      this.instructorEligibility__I = v || undefined;
      this.instructorEligibilityIsSet = false;
    }
    this.changeTracker = true;
  }
  get instructorEligibility() {
    return this.instructorEligibility__I;
  }
  existingSignup__I?: ClassSignupDTOTracked = undefined;
  existingSignupIsSet: boolean = false;
  set existingSignup(v: undefined | ClassSignupDTOTracked) {
    if (v !== undefined) {
      this.existingSignup__I = v;
      this.existingSignupIsSet = true;
    } else {
      this.existingSignup__I = v || undefined;
      this.existingSignupIsSet = false;
    }
    this.changeTracker = true;
  }
  get existingSignup() {
    return this.existingSignup__I;
  }
  constructor(
    config?: PersonClassEligibilityOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.personId?.setIds();

    this.instructorEligibility?.setIds();

    this.existingSignup?.setIds();
  }
  assignFrom(
    config: PersonClassEligibilityOptional,
    options?: AssignOptions,
  ): PersonClassEligibilityTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.personId && this.personIdApplyFilter(optionsRequired.filter)) {
      this.personId = new PersonNameInfoAndRefTracked(config.personId, options);
      if (optionsRequired.unassign) this.personIdIsSet = false;
      else this.personIdIsSet = true;
    }
    if (
      config.eligibilityStatus &&
      this.eligibilityStatusApplyFilter(optionsRequired.filter)
    ) {
      this.eligibilityStatus = config.eligibilityStatus;
      if (optionsRequired.unassign) this.eligibilityStatusIsSet = false;
      else this.eligibilityStatusIsSet = true;
    }
    if (config.message && this.messageApplyFilter(optionsRequired.filter)) {
      this.message = config.message;
      if (optionsRequired.unassign) this.messageIsSet = false;
      else this.messageIsSet = true;
    }
    if (
      config.instructorEligibility &&
      this.instructorEligibilityApplyFilter(optionsRequired.filter)
    ) {
      this.instructorEligibility =
        new ClassSignupInstructorEligibilityDTOTracked(
          config.instructorEligibility,
          options,
        );
      if (optionsRequired.unassign) this.instructorEligibilityIsSet = false;
      else this.instructorEligibilityIsSet = true;
    }
    if (
      config.existingSignup &&
      this.existingSignupApplyFilter(optionsRequired.filter)
    ) {
      this.existingSignup = new ClassSignupDTOTracked(
        config.existingSignup,
        options,
      );
      if (optionsRequired.unassign) this.existingSignupIsSet = false;
      else this.existingSignupIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonClassEligibilityTrackedI {
    const cloned = {} as PersonClassEligibilityTrackedI;
    if (
      this.personIdIsSetDeep() &&
      this.personIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personIdIsSet = true;
      cloned.personId = this.personId?.removeUnset(filter);
    } else {
      //cloned.personIdIsSet = false
    }
    if (
      this.eligibilityStatusIsSetDeep() &&
      this.eligibilityStatusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.eligibilityStatusIsSet = true;
      cloned.eligibilityStatus = this.eligibilityStatus;
    } else {
      //cloned.eligibilityStatusIsSet = false
    }
    if (
      this.messageIsSetDeep() &&
      this.messageApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.messageIsSet = true;
      cloned.message = this.message;
    } else {
      //cloned.messageIsSet = false
    }
    if (
      this.instructorEligibilityIsSetDeep() &&
      this.instructorEligibilityApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.instructorEligibilityIsSet = true;
      cloned.instructorEligibility =
        this.instructorEligibility?.removeUnset(filter);
    } else {
      //cloned.instructorEligibilityIsSet = false
    }
    if (
      this.existingSignupIsSetDeep() &&
      this.existingSignupApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.existingSignupIsSet = true;
      cloned.existingSignup = this.existingSignup?.removeUnset(filter);
    } else {
      //cloned.existingSignupIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonClassEligibilityTrackedI {
    if (!this.personIdApplyFilter(filter)) this.personIdIsSet = false;
    this.personId?.unassignAll(filter);

    if (!this.eligibilityStatusApplyFilter(filter))
      this.eligibilityStatusIsSet = false;

    if (!this.messageApplyFilter(filter)) this.messageIsSet = false;

    if (!this.instructorEligibilityApplyFilter(filter))
      this.instructorEligibilityIsSet = false;
    this.instructorEligibility?.unassignAll(filter);

    if (!this.existingSignupApplyFilter(filter))
      this.existingSignupIsSet = false;
    this.existingSignup?.unassignAll(filter);

    return this;
  }
  personIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonClassEligibilityMeta.personId,
      PersonClassEligibilityMeta,
      this.personId,
      this,
    );
  }
  personIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personIdIsSet && this.personIdApplyFilter(filter)) return true;
    return this.personId?.anySet(filter) == true;

    return false;
  }
  eligibilityStatusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonClassEligibilityMeta.eligibilityStatus,
      PersonClassEligibilityMeta,
      this.eligibilityStatus,
      this,
    );
  }
  eligibilityStatusIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.eligibilityStatusIsSet &&
      this.eligibilityStatusApplyFilter(filter)
    )
      return true;

    return false;
  }
  messageApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonClassEligibilityMeta.message,
      PersonClassEligibilityMeta,
      this.message,
      this,
    );
  }
  messageIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.messageIsSet && this.messageApplyFilter(filter)) return true;

    return false;
  }
  instructorEligibilityApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonClassEligibilityMeta.instructorEligibility,
      PersonClassEligibilityMeta,
      this.instructorEligibility,
      this,
    );
  }
  instructorEligibilityIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.instructorEligibilityIsSet &&
      this.instructorEligibilityApplyFilter(filter)
    )
      return true;
    return this.instructorEligibility?.anySet(filter) == true;

    return false;
  }
  existingSignupApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonClassEligibilityMeta.existingSignup,
      PersonClassEligibilityMeta,
      this.existingSignup,
      this,
    );
  }
  existingSignupIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.existingSignupIsSet && this.existingSignupApplyFilter(filter))
      return true;
    return this.existingSignup?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.personIdIsSetDeep(filter)) return true;
    if (this.eligibilityStatusIsSetDeep(filter)) return true;
    if (this.messageIsSetDeep(filter)) return true;
    if (this.instructorEligibilityIsSetDeep(filter)) return true;
    if (this.existingSignupIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
